module.exports = __webpack_public_path__ + "static/img/car.6761d3da.svg";